import { render, staticRenderFns } from "./Expenses.vue?vue&type=template&id=3c89bb77&scoped=true&"
import script from "./Expenses.vue?vue&type=script&lang=js&"
export * from "./Expenses.vue?vue&type=script&lang=js&"
import style0 from "./Expenses.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Expenses.vue?vue&type=style&index=1&id=3c89bb77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c89bb77",
  null
  
)

export default component.exports